import { render } from "./HubStatus.vue?vue&type=template&id=6872ef4e"
import script from "./HubStatus.vue?vue&type=script&lang=js"
export * from "./HubStatus.vue?vue&type=script&lang=js"

import "./HubStatus.vue?vue&type=style&index=0&id=6872ef4e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__